// src/layout/Header.jsx
import React from "react";
import { Link } from "react-router-dom";

const sizeMap = {
  sm: "h-12 text-sm",
  md: "h-16 text-base",
  lg: "h-20 text-lg",
  xl: "h-24 text-xl",
};

export function Header({
  size = "md",
  start = null, // left area: logo, back button, etc.
  center = null, // middle: title, search, tabs
  end = null, // right: user menu, actions
  className = "",
  sticky = true, // easily toggle sticky behavior
}) {
  const sz = sizeMap[size] ?? sizeMap.md;
  return (
    <header
      className={[
        "w-full",
        sticky ? "sticky top-0 z-40" : "",
        sz,
        className,
      ].join(" ")}
      role="banner"
    >
      {/* <div className="mx-auto max-w-screen-xl h-full px-4 flex items-center gap-3"> */}
      <div className="w-100 d-flex justify-content-between align-items-center">
        {start}
        {center}
        {end}
      </div>
    </header>
  );
}
